import React, { useState, useEffect } from "react";
import ColorsTools from "./Tools_Components/Colors_Tools";
import LayersTools from "./Tools_Components/Layers_Tools";
import GeometryTools from "./Tools_Components/Geometry_Tools";
import ChaosTools from "./Tools_Components/Chaos_Tools";
import OrderTools from "./Tools_Components/Order_Tools";
import PowerFilterTools from "./Tools_Components/Power_Filter_Tools";
import ImageTools from "./Tools_Components/Image_Tools";
import StickiesTools from "./Tools_Components/Stickies_Tools";
import JargonTools from "./Tools_Components/Jargon_Tools";
import TextTools from "./Tools_Components/Text_Tools";
import SeriesTools from "./Tools_Components/Series_Tools";
import ComingSoonDivider from "./PowerPack_Common/ComingSoonDivider";
import ToolsetButtonLister from "./PowerPack_Common/ToolsetButtonLister";
import { sortLeftRightTopBottom } from "../refractCommon/miro/sortLeftRightTopBottom";
import colors_bkg from "../images/toolpack_button_images/Colors_Bkg_3.png";
import geometry_bkg from "../images/toolpack_button_images/Geometry_1.png";
import order_bkg from "../images/toolpack_button_images/Order_1.png";
import jargon_bkg from "../images/toolpack_button_images/Jargon_1.png";
import series_bkg from "../images/toolpack_button_images/Series_3.png";
import text_bkg from "../images/toolpack_button_images/Text_1.png";

const { board } = window.miro;
const miro = window.miro;

export default function Tools({
  isPro,
  environment,
  selectedToolset,
  setSelectedToolset,
  toolSelected,
  setToolSelected,
}) {
  const [boardSelection, setBoardSelection] = useState([]);
  const [appData, setAppData] = useState([]);

  let userIsPro = isPro;

  useEffect(async () => {
    const initBoardSelection = await board.getSelection();
    setBoardSelection(initBoardSelection);
  }, []);

  // BOARD SELECTION LISTENER AND STATE/CONTEXT SETTTING
  const [listenerSet, setListenerSet] = useState(false);
  useEffect(() => {
    if (!listenerSet) {
      subscribe();
    }
  }, []);

  async function subscribe() {
    // Listen to the 'selection:update' event
    await board.ui.on("selection:update", async (event) => {
      handleSetBoardSelection(event.items);
    });
    setListenerSet(true);
  }

  function handleSetBoardSelection(items) {
    let sorted = sortLeftRightTopBottom(items);
    setBoardSelection(sorted);
  }
  // get app data from board
  // useEffect(async () => {
  //   let appData = await miro.board.getAppData("board");
  //   setAppData(appData);
  // }, []);

  //  T O O L S E T S       ----------------------------------------

  const toolsetList = [
    {
      toolset_name: "Text",
      toolset_icon_classname: "icon-text",
      toolset_short_description: "",
      status_prod_ready: true,
      pro_tools_in_set: "none",
      status_message: "",
      toolbutton_bkg_image_url: text_bkg,
    },

    {
      toolset_name: "Series",
      toolset_icon_classname: "icon-numbered-list",
      toolset_short_description: "",
      status_prod_ready: true,
      pro_tools_in_set: "none",
      status_message: "",
      toolbutton_bkg_image_url: series_bkg,
    },
    {
      toolset_name: "Order",
      toolset_icon_classname: "icon-analytics",
      toolset_short_description: "",
      status_prod_ready: true,
      pro_tools_in_set: "none",
      status_message: "",
      toolbutton_bkg_image_url: order_bkg,
    },
    {
      toolset_name: "Geometry",
      // toolset_icon_classname: "icon-drag",
      toolset_icon_classname: "icon-triangle",
      toolset_short_description: "",
      status_prod_ready: true,
      pro_tools_in_set: "none",
      status_message: "",
      toolbutton_bkg_image_url: geometry_bkg,
    },
    {
      toolset_name: "Colors",
      toolset_icon_classname: "icon-pen",
      toolset_short_description: "",
      status_prod_ready: true,
      status_UAT_ready: true,
      pro_tools_in_set: "none",
      status_message: "SOME PRO",
      toolbutton_bkg_image_url: colors_bkg,
    },
    {
      toolset_name: "Stickies",
      toolset_icon_classname: "icon-sticky-bulk",
      toolset_short_description: "",
      status_prod_ready: false,
      status_UAT_ready: true,
      pro_tools_in_set: "none",
      status_message: "",
      toolbutton_bkg_image_url: colors_bkg,
    },
    {
      toolset_name: "Jargon",
      toolset_icon_classname: "icon-comment-feedback",
      toolset_short_description: "",
      status_prod_ready: true,
      pro_tools_in_set: "none",
      status_message: "",
      toolbutton_bkg_image_url: jargon_bkg,
    },

    {
      toolset_name: "Chaos",
      toolset_icon_classname: "icon-activity",
      toolset_short_description: "",
      status_prod_ready: false,
      status_UAT_ready: false,
      pro_tools_in_set: "none",
      status_message: "",
    },
    {
      toolset_name: "Images",
      toolset_icon_classname: "icon-image",
      toolset_short_description: "",
      status_prod_ready: false,
      status_UAT_ready: false,
      pro_tools_in_set: "none",
      status_message: "PRO PLAN",
    },
    {
      toolset_name: "Power Filter",
      toolset_icon_classname: "icon-filters",
      toolset_short_description: "",
      status_prod_ready: false,
      status_UAT_ready: false,
      pro_tools_in_set: "none",
      status_message: "PRO PLAN",
    },
    {
      toolset_name: "Layers",
      toolset_icon_classname: "icon-layers",
      toolset_short_description: "",
      status_prod_ready: false,
      status_UAT_ready: false,
      pro_tools_in_set: "none",
      status_message: "PRO PLAN",
    },
  ];

  // Declare the subsets
  let prodToolsets = toolsetList.filter(
    (toolset) => toolset.status_prod_ready === true
  );

  let devToolsets = toolsetList.filter(
    (toolset) => toolset.status_prod_ready === false
  );

  // ----------------------------

  return (
    <div id="app-container">
      <div
        id="toolset-button-section grid"
        className="cs1 ce12 grid"
        style={{
          display: toolSelected ? "none" : "block",
        }}>
        <ToolsetButtonLister
          id="prod-ready-toolsets"
          environment={environment}
          isPro={isPro}
          selectedToolset={selectedToolset}
          setSelectedToolset={setSelectedToolset}
          toolSelected={toolSelected}
          setToolSelected={setToolSelected}
          toolsetSubsetList={prodToolsets}
        />

        <ComingSoonDivider visible={!toolSelected} />
        <ToolsetButtonLister
          id="coming-soon-tools"
          environment={environment}
          isPro={isPro}
          selectedToolset={selectedToolset}
          setSelectedToolset={setSelectedToolset}
          toolSelected={toolSelected}
          setToolSelected={setToolSelected}
          toolsetSubsetList={devToolsets}
        />
      </div>

      {/* THIS IS THE TOOL SET DIV */}
      <div
        style={{
          display: selectedToolset.toolset_name === "None" ? "none" : "block",
        }}>
        <div id="tool-buttons-container" className="">
          {selectedToolset.toolset_name === "Text" ? (
            <TextTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Series" ? (
            <SeriesTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Order" ? (
            <OrderTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Geometry" ? (
            <GeometryTools
              boardSelection={boardSelection}
              handleSetBoardSelection={handleSetBoardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Jargon" ? (
            <JargonTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Colors" ? (
            <ColorsTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
            />
          ) : selectedToolset.toolset_name === "Stickies" ? (
            <StickiesTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
            />
          ) : selectedToolset.toolset_name === "Chaos" ? (
            <ImageTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Images" ? (
            <ImageTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Power Filter" ? (
            <PowerFilterTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : selectedToolset.toolset_name === "Layers" ? (
            <LayersTools
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
              appData={appData}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
